/* eslint-disable sonarjs/no-duplicate-string */
export const colors = {
  row: {
    hover: 'rgba(224, 224, 224, 0.3)',
  },
  secondary: {
    default: 'rgba(38, 46, 61, 0.1)',
    hover: 'rgba(38, 46, 61, 0.17)',
  },
  text: {
    active: 'rgba(38, 46, 61, 1)',
    content: 'rgba(38, 46, 61, 0.8)',
    secondary: 'rgba(38, 46, 61, 0.55)',
    disabled: 'rgba(38, 46, 61, 0.3)',
    link: 'rgba(54, 163, 217, 1)',
    accented: 'rgba(12, 14, 18, 1)',
    linkButton: '#1eaff3',
    primary: '#262E3D',
  },
  UI: {
    default: '#6e737d',
    additional: 'rgba(38, 46, 61, 0.4)',
    guiding: 'rgba(38, 46, 61, 0.1)',
  },
  background: {
    workspace: 'rgba(255, 255, 255, 1)',
    supporting: 'rgba(249, 249, 251, 1)',
    priority: 'rgba(244, 244, 248, 1)',
  },
  primary: {
    primary: 'rgba(255, 203, 5, 1)',
    default: '#FFC805',
    hover: '#F2B900',
  },
  interaction: {
    defaultHover: 'rgba(12, 14, 18, 0.07)',
    guidingHover: 'rgba(38, 46, 61, 0.17)',
    linkHovered: 'rgba(50, 147, 197, 1)',
    primaryHovered: 'rgba(242, 185, 0, 1)',
  },
  semantic: {
    info: 'rgba(52, 150, 200, 1)',
    success: 'rgba(34, 195, 195, 1)',
    warning: 'rgba(242, 185, 0, 1)',
    error: 'rgba(231, 71, 39, 1)',
    infoBG: 'rgba(52, 150, 200, 0.1)',
    successBG: 'rgba(34, 195, 195, 0.1)',
    warningBG: 'rgba(242, 185, 0, 0.1)',
    errorBG: 'rgba(231, 71, 39, 0.1)',
  },
  sisenseDark: {
    text: {
      active: 'rgba(235, 239, 247, 1)',
      content: 'rgba(235, 239, 247, 0.8)',
      secondary: 'rgba(235, 239, 247, 0.55)',
      disabled: 'rgba(235, 239, 247, 0.3)',
      link: 'rgba(50, 147, 197, 1)',
      accented: 'rgba(12, 14, 18, 1)',
    },
    ui: {
      default: 'rgba(235, 239, 247, 0.67)',
      additional: 'rgba(235, 239, 247, 0.4)',
      guiding: 'rgba(235, 239, 247, 0.1)',
    },
    background: {
      workspace: 'rgba(12, 14, 18, 1)',
      supporting: 'rgba(249, 249, 251, 1)',
      priority: 'rgba(244, 244, 248, 1)',
    },
    interaction: {
      defaultHover: 'rgba(12, 14, 18, 0.07)',
      guidingHover: 'rgba(235, 239, 247, 0.17)',
      linkHovered: 'rgba(50, 147, 197, 1)',
      primaryHovered: 'rgba(242, 185, 0, 1)',
    },
    semantic: {
      info: 'rgba(52, 150, 200, 1)',
      success: 'rgba(34, 195, 195, 1)',
      warning: 'rgba(242, 185, 0, 1)',
      error: 'rgba(231, 71, 39, 1)',
      infoBG: 'rgba(52, 150, 200, 0.1)',
      successBG: 'rgba(34, 195, 195, 0.1)',
      warningBG: 'rgba(242, 185, 0, 0.1)',
      errorBG: 'rgba(231, 71, 39, 0.1)',
    },
  },
};
